<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" id="projectTitle">Status projeto</h5>
    <button type="button" class="close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group col-md-12">
      <div class="input-group">
        <div class="input-group-prepend">
          <label class="input-group-text" for="status">Status</label>
        </div>

        <select class="custom-select" id="status" [(ngModel)]="project.status">
          <option *ngFor="let item of status" [value]="item.value" selected>{{ item.description }}</option>
        </select>
      </div>
    </div>

    <div class="form-group col-md-12" [hidden]="project.status !== 'presenting'">
      <label for="presenting">Qual o estado da apresentação?</label>
      <select class="custom-select" id="presenting" [(ngModel)]="project.presenting_status">
        <option *ngFor="let item of presenting" [value]="item.value">{{ item.description }}</option>
      </select>
    </div>

    <div
      class="form-group col-md-12"
      *ngIf="project.status === 'presenting' &&
        (project.presenting_status === 'qualification' ||
        project.presenting_status === 'vindication')">
      <label for="presenting_date">Qual a data?</label>
      <input type="text" data-inputmask="'mask': '99/99/9999'" [(ngModel)]="project.presenting_date" (click)="d.toggle()"
        ngbDatepicker #d="ngbDatepicker" class="form-control inputmask" id="presenting_date">
    </div>

    <div
      class="form-group col-md-12"
      *ngIf="project.status === 'subject'">
      <label for="subject_date">Qual a data de submissão?</label>
      <input type="text" data-inputmask="'mask': '99/99/9999'" [(ngModel)]="project.subject_date" (click)="d.toggle()"
        ngbDatepicker #d="ngbDatepicker" class="form-control inputmask" id="subject_date">
    </div>

    <div class="form-group col-md-12" [hidden]="project.status !== 'published'">
      <label for="published">Qual a data de publicação?</label>
      <input type="text" data-inputmask="'mask': '99/99/9999'" [(ngModel)]="project.published" (click)="d.toggle()"
        ngbDatepicker #d="ngbDatepicker" class="form-control inputmask" id="published">
    </div>

    <div [formGroup]="projectForm" *ngIf="project.status !== 'created' && project.status !== 'development'">
      <div class="page-header"> <i class="fa fa-sticky-note" aria-hidden="true"></i> Lembrete</div>
      <hr>
      <div
        class="form-group col-md-12"
        *ngIf="project.status === 'subject' || project.status === 'published'"
      >
        <label for="magazine">Revista</label>
        <input type="text" id="magazine" class="form-control" formControlName="magazine" [(ngModel)]="stiker.magazine"
          [ngClass]="{ 'is-invalid': submitted && projectForm.get('magazine').hasError('required') }">
        <small class="invalid-feedback" *ngIf="submitted && projectForm.get('magazine').hasError('required')">
          A revista não foi informado
        </small>
      </div>
      <div class="form-group col-md-12">
        <label for="description">Observação</label>
        <textarea placeholder="escreva aqui..." id="description" class="form-control" formControlName="description"
          [(ngModel)]="stiker.description"></textarea>
      </div>
      <div class="form-group col-md-12">
        <div class="row align-items-center justify-content-between">
          <div class="col pr-0">
            <small>Lembre-me a cada</small>
          </div>
          <div class="col">
            <input type="number" min="0" id="each_day" class="form-control" formControlName="each_day"
              [(ngModel)]="stiker.each_day">
          </div>
          <div class="col pl-0">
            <small>dias
              <span *ngIf="project.status === 'presenting' &&
              (project.presenting_status === 'qualification')"> até a qualificação</span>
              <span *ngIf="project.status === 'presenting' &&
              (project.presenting_status === 'vindication')"> até a defesa</span>
            </small>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-linkr mainFontColor" (click)="activeModal.dismiss()">Voltar</button>
    <button type="button" (click)="save()" btnloader class="btn btn-primary mainBackground-color">
      Salvar
    </button>
  </div>
</div>
